import { ErrorCodes } from "../../../Exception/ErrorCodes";
import { ErrorStatuses } from "../../../Exception/ErrorStatuses";
import { ErrorMessages } from "../../../Global/Messages/Messages";
import BaseValidator from "../../../Global/Validator/BaseValidator";

export default class StandingGameValidator extends BaseValidator {
  public validatePrediction = (prediction: string[]) => {
    if (
      !prediction ||
      !Array.isArray(prediction) ||
      prediction.length === 0 ||
      prediction.some((p) => !p)
    ) {
      this.throwException(
        ErrorCodes.BAD_METHOD_CALL,
        ErrorStatuses.INVALID_METHOD_CALL,
        ErrorMessages.INVALID_STANDING_PREDICTION_ARGUMENT
      );
    }
  };
}
